function handleClick(menu){
   menu.button.addEventListener("click", (evt)=>{
      evt.preventDefault();
      menu.open = !menu.open;
      menu.apply();
   });
}

class MenuToggle{
   constructor(options){
      this.open = false;
      this.button = options.button;
      this.menu = options.menu;
      this.openClass = options.openClass || "open";
      handleClick(this);
   }

   apply(){
      this.button.classList.toggle(this.openClass, this.open);
      this.menu.classList.toggle(this.openClass, this.open);
   }
}

export default function init(){
   const hamburgerButton = document.getElementById("hamburger-button");
   const hamburgerMenu = document.getElementById("hamburger-menu");

   if(hamburgerButton && hamburgerMenu){
      new MenuToggle({
         button: hamburgerButton,
         menu: hamburgerMenu
      });
      
      hamburgerButton.addEventListener('click', () => {
         if (!hamburgerMenu.classList.contains('open')) {
            hamburgerMenu.classList.remove('flyout-active');
            document.querySelectorAll('.hamburger-flyout-panel.active').forEach(panel => {
               panel.classList.remove('active');
            });
         }
      });
   }
}

function initDropdownIcons() {
   document.querySelectorAll('[data-dropdown-icon]').forEach(icon => {
      icon.addEventListener('click', (event) => {
         const parent = event.currentTarget.closest('.flex-space-between');
         const submenu = parent?.querySelector('.submenu');
         const arrowIcon = icon.querySelector('.icon-arrow-down');

         if (submenu) {
            if (submenu.classList.contains('visible')) {
               submenu.style.maxHeight = null;
            } else {
               submenu.style.maxHeight = submenu.scrollHeight + "px";
            }
            submenu.classList.toggle('visible');
         }

         arrowIcon?.classList.toggle('rotated');
      });
   });
}

function initHamburgerFlyoutMenus() {
   const hamburgerMenu = document.getElementById('hamburger-menu');
   if (!hamburgerMenu) return;
   
   document.querySelectorAll('[data-flyout-hamburger-trigger]').forEach(trigger => {
      const link = trigger.querySelector('[data-flyout-hamburger-link]');
      const arrow = trigger.querySelector('[data-flyout-hamburger-arrow]');
      const index = trigger.getAttribute('data-flyout-index');
      const panel = document.querySelector(`[data-flyout-hamburger-panel][data-flyout-panel-index="${index}"]`);
      
      if (!link || !panel) return;
      
      const openFlyout = (event) => {
         event.preventDefault();
         hamburgerMenu.classList.add('flyout-active');
         panel.classList.add('active');
         
         const firstLink = panel.querySelector('.hamburger-flyout-content a');
         if (firstLink) {
            setTimeout(() => firstLink.focus(), 50);
         }
      };
      
      link.addEventListener('click', openFlyout);
      arrow?.addEventListener('click', openFlyout);
      
      const closeFlyout = (event) => {
         event.preventDefault();
         hamburgerMenu.classList.remove('flyout-active');
         panel.classList.remove('active');
         link.focus();
      };
      
      const backButton = panel.querySelector('[data-flyout-back-button]');
      backButton?.addEventListener('click', closeFlyout);
   });
}

function initKeyboardNavigation() {
   const mainNav = document.querySelector('nav.main-navigation');
   if (!mainNav) return;

   const linksContainer = mainNav.querySelector('.links');
   if (!linksContainer) return;

   let currentOpenMenu = null;

   function isDesktop() {
      return window.matchMedia('(hover: hover) and (min-width: 1025px)').matches;
   }

   function closeAllMenus() {
      if (!currentOpenMenu) return;

      const trigger = currentOpenMenu.trigger;
      trigger.parentElement.classList.remove('keyboard-open');
      trigger.setAttribute('aria-expanded', 'false');
      currentOpenMenu = null;
   }

   function openMenu(trigger, menu, menuType) {
      closeAllMenus();
      trigger.parentElement.classList.add('keyboard-open');
      trigger.setAttribute('aria-expanded', 'true');
      currentOpenMenu = { trigger, menu, type: menuType };

      const firstLink = menu.querySelector('a[role="menuitem"]');
      if (firstLink) {
         firstLink.focus();
      }
   }

   function getAllMainNavItems() {
      return Array.from(linksContainer.querySelectorAll(':scope > a, :scope > .menu-item > a[data-flyout-link], :scope > .menu-item > a[data-dropdown-link]'));
   }

   function getMenuItems(menu) {
      return Array.from(menu.querySelectorAll('a[role="menuitem"]'));
   }

   linksContainer.addEventListener('focusin', (event) => {
      const target = event.target;

      if (target.closest('.flyout-menu') || target.closest('.submenu')) {
         return;
      }

      const flyoutTrigger = target.closest('[data-flyout-trigger]');
      const dropdownTrigger = target.closest('[data-dropdown-trigger]');
      
      if (!flyoutTrigger && !dropdownTrigger) {
         closeAllMenus();
      }
   });

   linksContainer.addEventListener('keydown', (event) => {
      const target = event.target;
      const key = event.key;
      const isInFlyout = target.closest('.flyout-menu');
      const isInDropdown = target.closest('.submenu');
      const isMainNav = !isInFlyout && !isInDropdown;

      if (key === 'Enter' && isMainNav && isDesktop()) {
         const flyoutTrigger = target.closest('[data-flyout-trigger]');
         const dropdownTrigger = target.closest('[data-dropdown-trigger]');
         
         if (flyoutTrigger && target.hasAttribute('data-flyout-link')) {
            const menu = flyoutTrigger.querySelector('.flyout-menu');
            if (menu && !currentOpenMenu) {
               event.preventDefault();
               openMenu(target, menu, 'flyout');
            }
         } else if (dropdownTrigger && target.hasAttribute('data-dropdown-link')) {
            const menu = dropdownTrigger.querySelector('.submenu');
            if (menu && !currentOpenMenu) {
               event.preventDefault();
               openMenu(target, menu, 'dropdown');
            }
         }
         return;
      }

      if (key === 'Escape') {
         if (currentOpenMenu) {
            event.preventDefault();
            const triggerToFocus = currentOpenMenu.trigger;
            closeAllMenus();
            triggerToFocus.focus();
         }
         return;
      }

      if ((isInFlyout || isInDropdown) && currentOpenMenu) {
         const menuItems = getMenuItems(currentOpenMenu.menu);
         const currentIndex = menuItems.indexOf(target);

         if (key === 'ArrowDown') {
            event.preventDefault();
            const nextIndex = (currentIndex + 1) % menuItems.length;
            menuItems[nextIndex].focus();
         } else if (key === 'ArrowUp') {
            event.preventDefault();
            const prevIndex = currentIndex === 0 ? menuItems.length - 1 : currentIndex - 1;
            menuItems[prevIndex].focus();
         } else if (key === 'ArrowLeft' || key === 'ArrowRight') {
            // Navigate to next/previous main menu item
            event.preventDefault();
            const mainNavItems = getAllMainNavItems();
            const triggerIndex = mainNavItems.indexOf(currentOpenMenu.trigger);
            
            let nextTriggerIndex;
            if (key === 'ArrowRight') {
               nextTriggerIndex = (triggerIndex + 1) % mainNavItems.length;
            } else {
               nextTriggerIndex = triggerIndex === 0 ? mainNavItems.length - 1 : triggerIndex - 1;
            }
            
            closeAllMenus();
            mainNavItems[nextTriggerIndex].focus();
         }
      } else if (isMainNav) {
         if (key === 'ArrowLeft' || key === 'ArrowRight') {
            event.preventDefault();
            const mainNavItems = getAllMainNavItems();
            const currentIndex = mainNavItems.indexOf(target);
            
            let nextIndex;
            if (key === 'ArrowRight') {
               nextIndex = (currentIndex + 1) % mainNavItems.length;
            } else {
               nextIndex = currentIndex === 0 ? mainNavItems.length - 1 : currentIndex - 1;
            }
            
            mainNavItems[nextIndex].focus();
         }
      }
   });

   document.addEventListener('click', (event) => {
      if (currentOpenMenu && !event.target.closest('.menu-item')) {
         closeAllMenus();
      }
   });

   document.addEventListener('focusin', (event) => {
      if (currentOpenMenu && !linksContainer.contains(event.target)) {
         closeAllMenus();
      }
   });
}

function initMobileKeyboardNavigation() {
   const hamburgerButton = document.getElementById('hamburger-button');
   const hamburgerMenu = document.getElementById('hamburger-menu');
   
   if (!hamburgerButton || !hamburgerMenu) return;

   hamburgerButton.setAttribute('tabindex', '0');
   hamburgerButton.setAttribute('role', 'button');
   hamburgerButton.setAttribute('aria-label', 'Open menu');
   hamburgerButton.setAttribute('aria-expanded', 'false');

   let activeFlyoutTrigger = null;

   function isMobile() {
      return window.matchMedia('(max-width: 1024px)').matches;
   }

   function getFocusableElements() {
      return hamburgerMenu.querySelectorAll('a, button, [tabindex]');
   }

   function disableMenuTabbing() {
      getFocusableElements().forEach(element => {
         element.setAttribute('tabindex', '-1');
      });
   }

   function enableMenuTabbing() {
      getFocusableElements().forEach(element => {
         element.setAttribute('tabindex', '0');
      });
   }

   function openHamburgerMenu() {
      hamburgerButton.classList.add('open');
      hamburgerMenu.classList.add('open');
      hamburgerButton.setAttribute('aria-expanded', 'true');
      hamburgerButton.setAttribute('aria-label', 'Close menu');
      enableMenuTabbing();
      
      const firstLink = hamburgerMenu.querySelector('[data-hamburger-content] a, [data-hamburger-content] button');
      if (firstLink) {
         setTimeout(() => firstLink.focus(), 50);
      }
   }

   function closeHamburgerMenu() {
      hamburgerButton.classList.remove('open');
      hamburgerMenu.classList.remove('open');
      hamburgerButton.setAttribute('aria-expanded', 'false');
      hamburgerButton.setAttribute('aria-label', 'Open menu');
      
      hamburgerMenu.classList.remove('flyout-active');
      document.querySelectorAll('.hamburger-flyout-panel.active').forEach(panel => {
         panel.classList.remove('active');
      });
      
      disableMenuTabbing();
      hamburgerButton.focus();
      activeFlyoutTrigger = null;
   }

   disableMenuTabbing();

   function isInFlyoutPanel(element) {
      return element.closest('.hamburger-flyout-panel.active') !== null;
   }

   function getVisibleFocusableElements(container) {
      const allElements = Array.from(container.querySelectorAll('a, button, [tabindex="0"]'));
      return allElements.filter(el => {
         const style = window.getComputedStyle(el);
         if (style.display === 'none' || style.visibility === 'hidden') return false;
         const rect = el.getBoundingClientRect();
         return rect.width !== 0 || rect.height !== 0;
      });
   }

   function handleFocusTrap(event, elements) {
      if (elements.length === 0) return;
      
      const currentIndex = elements.indexOf(event.target);
      if (currentIndex === -1) {
         elements[0].focus();
         return;
      }

      if (event.shiftKey) {
         const prevIndex = currentIndex <= 0 ? elements.length - 1 : currentIndex - 1;
         elements[prevIndex].focus();
      } else {
         const nextIndex = currentIndex >= elements.length - 1 ? 0 : currentIndex + 1;
         elements[nextIndex].focus();
      }
   }

   hamburgerButton.addEventListener('keydown', (event) => {
      if (!isMobile()) return;
      
      if (event.key === 'Enter' || event.key === ' ') {
         event.preventDefault();
         const isOpen = hamburgerMenu.classList.contains('open');
         
         if (isOpen) {
            closeHamburgerMenu();
         } else {
            openHamburgerMenu();
         }
      }
   });

   hamburgerMenu.addEventListener('keydown', (event) => {
      if (!isMobile()) return;
      
      const target = event.target;
      const key = event.key;

      if (key === 'Tab') {
         const activePanel = document.querySelector('.hamburger-flyout-panel.active');
         
         if (activePanel) {
            event.preventDefault();
            const focusableElements = getVisibleFocusableElements(activePanel);
            handleFocusTrap(event, focusableElements);
            return;
         } else if (hamburgerMenu.classList.contains('open')) {
            event.preventDefault();
            const mainContent = hamburgerMenu.querySelector('[data-hamburger-content]');
            if (!mainContent) return;
            
            const focusableElements = getVisibleFocusableElements(mainContent).filter(el => {
               return el.getAttribute('tabindex') !== '-1';
            });
            handleFocusTrap(event, focusableElements);
            return;
         }
      }

      if (key === 'Escape') {
         event.preventDefault();
         const activePanel = document.querySelector('.hamburger-flyout-panel.active');
         
         if (activePanel) {
            hamburgerMenu.classList.remove('flyout-active');
            activePanel.classList.remove('active');
            
            if (activeFlyoutTrigger) {
               activeFlyoutTrigger.focus();
               activeFlyoutTrigger = null;
            }
         } else {
            closeHamburgerMenu();
         }
         return;
      }

      if (key === 'Enter') {
         const flyoutTrigger = target.closest('[data-flyout-hamburger-trigger]');
         const backButton = target.closest('[data-flyout-back-button]');
         
         if (flyoutTrigger && !isInFlyoutPanel(target)) {
            const link = flyoutTrigger.querySelector('[data-flyout-hamburger-link]');
            const index = flyoutTrigger.getAttribute('data-flyout-index');
            const panel = document.querySelector(`[data-flyout-hamburger-panel][data-flyout-panel-index="${index}"]`);
            
            if (panel) {
               event.preventDefault();
               activeFlyoutTrigger = link || target;
               hamburgerMenu.classList.add('flyout-active');
               panel.classList.add('active');
               
               const backButton = panel.querySelector('[data-flyout-back-button]');
               if (backButton) {
                  setTimeout(() => backButton.focus(), 50);
               } else {
                  const firstLink = panel.querySelector('.hamburger-flyout-content a');
                  if (firstLink) {
                     setTimeout(() => firstLink.focus(), 50);
                  }
               }
            }
         } else if (backButton) {
            event.preventDefault();
            const panel = backButton.closest('.hamburger-flyout-panel');
            
            if (panel) {
               hamburgerMenu.classList.remove('flyout-active');
               panel.classList.remove('active');
               
               if (activeFlyoutTrigger) {
                  activeFlyoutTrigger.focus();
                  activeFlyoutTrigger = null;
               }
            }
         }
      }
   });

   const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
         if (mutation.attributeName === 'class') {
            const isOpen = hamburgerMenu.classList.contains('open');
            hamburgerButton.setAttribute('aria-expanded', isOpen.toString());
            hamburgerButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
            
            if (isOpen) {
               enableMenuTabbing();
            } else {
               disableMenuTabbing();
            }
         }
      });
   });
   
   observer.observe(hamburgerMenu, { attributes: true, attributeFilter: ['class'] });
}

document.addEventListener('DOMContentLoaded', () => {
   initDropdownIcons();
   initHamburgerFlyoutMenus();
   initKeyboardNavigation();
   initMobileKeyboardNavigation();
});
